<div
  *ngIf="availableFilters?.filters && availableFilters.filters.length > 0"
  class="width-100"
  [ngClass]="{ topic: embeddedComponent }"
>
  <h3 class="advHeading" *ngIf="availableFilters.filterLabel">
    {{ availableFilters.filterLabel }}
    <ng-container *ngIf="embeddedComponent">
      <a
        *ngIf="expandCollapse; else showExpand"
        tabindex="0"
        (click)="collapseRefine()"
        (keyup.enter)="collapseRefine()"
        ><span class="linkText">(Collapse )</span>
      </a>
      <ng-template #showExpand>
        <a tabindex="0" (click)="expandRefine()" (keyup.enter)="expandRefine()"
          ><span class="linkText">(Expand )</span>
        </a>
      </ng-template>
    </ng-container>
  </h3>
  <div *ngIf="(!embeddedComponent || expandCollapse) && availableFilters.filters">
    <!-- Search by Date and Sort Order -->
    <div *ngFor="let filter of availableFilters.filters; let i = index; trackBy: trackById">
      <div class="advSearchOptions" *ngIf="filter?.filterId === 1">
        <label for="refineLibrarySelect">{{ filter?.title }} - </label>
        <select
          *ngIf="filter?.dropdownFields"
          id="refineLibrarySelect"
          class="refineLibrarySelect"
          [class]="'filter' + filter?.filterId"
          (change)="selectFiltersDate($event)"
        >
          <option
            *ngFor="let option of filter?.dropdownFields"
            [value]="option.value"
            [selected]="option.selected"
          >
            {{ option.name }}
          </option>
        </select>
      </div>
      <div *ngIf="filter.filterId === 2" class="advSearchOptions">
        <label for="refineLibrarySelect">{{ filter?.title }} - </label>
        <select
          *ngIf="filter?.dropdownFields"
          id="refineLibrarySelect"
          class="refineLibrarySelect"
          [class]="'filter' + filter?.filterId"
          (change)="selectFiltersLibraries($event)"
        >
          <option
            *ngFor="let option of filter?.dropdownFields"
            [value]="option.value"
            [selected]="option.selected"
          >
            {{ option.name }}
          </option>
        </select>
      </div>
      <div class="target-list row">
        <custom-advanced-filters
          *ngIf="
            filter.filterId === 3 ||
            filter.filterId === 6 ||
            filter.filterId === 10 ||
            filter.filterId === 11 ||
            filter.filterId === 14 ||
            filter.filterId === 15
          "
          class="width-100"
          [tooltip]="tooltip(filter.filterId)"
          [filter]="filter"
          [embeddedComponent]="embeddedComponent"
          [validators]="getValidators(filter.filterId)"
          [groupValidators]="getGroupValidators(filter.filterId)"
          [validationMessage]="getValidationMessages(filter.filterId)"
          (filterSelectedEE)="selectFilter($event)"
        >
        </custom-advanced-filters>

        <advanced-filters
          *ngIf="
            filter.filterId !== 1 &&
            filter.filterId !== 2 &&
            filter.filterId !== 3 &&
            filter.filterId !== 6 &&
            filter.filterId !== 10 &&
            filter.filterId !== 11 &&
            filter.filterId !== 14 &&
            filter.filterId !== 15
          "
          class="width-100"
          [filter]="filter"
          [embeddedComponent]="embeddedComponent"
          (filterSelectedEE)="selectFilter($event)"
        >
        </advanced-filters>
      </div>
    </div>
  </div>
</div>
